import Link from 'components/link';

export const TileLinkExternal = Link.withConfig({ isExternal: true });
